import { t } from "@lingui/core/macro";
import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, IconButton, TableBody, TextField } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

export const GenericDataTable = ({
    data,
    setLabels,
    onClickRow,
    header,
}: {
    data: string[] | null;
    setLabels?: (data: string[]) => void;
    onClickRow?: (id: number) => void;
    header: string;
}) => {
    const isEditable = !!setLabels;

    return (
        <TableContainer
            component={Paper}
            sx={{ maxHeight: "400px", borderRadius: 2, overflow: "hidden" }}
        >
            <Table stickyHeader size="small">
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ fontWeight: "bold", py: 1 }}>{header}</TableCell>
                        <TableCell align="right" sx={{ py: 1 }}>
                            {isEditable && (
                                <IconButton
                                    onClick={() => {
                                        const updatedEntrypoints = [
                                            ...(data || []),
                                            "",
                                        ];
                                        setLabels?.(updatedEntrypoints);
                                    }}
                                    color="primary"
                                    size="small"
                                >
                                    <AddIcon fontSize="small" />
                                </IconButton>
                            )}
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {(data || []).map((entryPoint, index) => (
                        <TableRow
                            key={index}
                            hover
                            onClick={() => onClickRow?.(index)}
                            sx={{ cursor: onClickRow ? "pointer" : "default" }}
                        >
                            <TableCell sx={{ p: 0.5 }}>
                                {isEditable ? (
                                    <TextField
                                        fullWidth
                                        value={entryPoint}
                                        onChange={(e) => {
                                            const updatedEntrypoints = [
                                                ...(data || []),
                                            ];
                                            updatedEntrypoints[index] = e.target.value;
                                            setLabels?.(updatedEntrypoints);
                                        }}
                                        size="small"
                                        sx={{
                                            "& .MuiOutlinedInput-root": {
                                                "& fieldset": { border: "none" },
                                                "& .MuiInputBase-input": { py: 0.5 },
                                            },
                                        }}
                                    />
                                ) : (
                                    entryPoint
                                )}
                            </TableCell>
                            <TableCell align="right" sx={{ pr: 2 }}>
                                {isEditable && (
                                    <IconButton
                                        onClick={() => {
                                            const updatedEntrypoints = (
                                                data || []
                                            ).filter((_, i) => i !== index);
                                            setLabels?.(updatedEntrypoints);
                                        }}
                                        color="primary"
                                        size="small"
                                    >
                                        <DeleteIcon fontSize="small" />
                                    </IconButton>
                                )}
                            </TableCell>
                        </TableRow>
                    ))}
                    {data?.length === 0 && (
                        <TableRow>
                            <TableCell colSpan={2} sx={{ textAlign: "center", py: 2 }}>
                                {t`No ${header} available. Add a new entry by clicking the button above.`}
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
};